export default [

     {
          path: '/national-risk-warning',
          name: 'NationalRiskWarning',
          component: () => import("@/views/Page/NationalRiskWarning/NationalRiskWarning.vue"),
          meta: {
               title: 'National Risk Warning',
          },
     }
];